const subjects = {};

export const registerCallback = (type, handler) => {
  if (!subjects[type]) {
    subjects[type] = handler;
  }
};
export const unregisterCallback = type => {
  if (subjects[type]) {
    delete subjects[type];
  }
};
export const isRegisteredCallback = type => {
  if (subjects[type]) {
    return true;
  }
  return false;
};

export const callbackService = {
  sendCallback: (type, payload) => {
    if (subjects[type]) {
      return subjects[type](payload);
    }
    return null;
  },
  callbacks: {
    beforeChangeOptionsCallback: "beforeChangeOptionsCallback",
    afterChangeOptionsCallback: "afterChangeOptionsCallback",
    afterChangePageOptionCallback: "afterChangePageOptionCallback",
    onCartSubmitCallback: "onCartSubmitCallback",
    beforeInitCallback: "beforeInitCallback",
    initFinalizeCallback: "initFinalizeCallback",
    beforePersonalizeCallback: "beforePersonalizeCallback",
    photoMappingCallback: "photoMappingCallback",
    toggleReadyToConnect: "toggleReadyToConnect",
    afterPersonalizationCallback: "afterPersonalizationCallback"
  }
};
